@if (spec) {
    <lm-builder-palette
            [businessClass]="businessClass"
            [facade]="facade"
            [moduleTag]="moduleTag"
            [canAdd]="canAdd"
            [addTooltip]="addTooltip"
            [dragTooltip]="dragTooltip"
            [dropTargets]="dropTargets"
            (advancedSearch)="handleAdvancedSearch()"
            (addField)="handleAddField($event)"
    >
    </lm-builder-palette>
}
@if(spec && spec.displayFields?.length > 0 || spec.cardView) {
    <div class="lm-builder-properties-tabs">
        <div soho-tabs [headerTabs]="true" [class.is-personalizable]="true">
            <div soho-tab-list-container>
                <ul soho-tab-list class="lm-builder-properties-tab-list">
                    <li soho-tab (click)="tabClicked('DISPLAY_FIELDS')">
                        <a soho-tab-title tabId="lm-builder-properties-columns" data-automation-id="lm-builder-properties-columns-tab">{{ 'Columns' | translate }}</a>
                    </li>
                    <li soho-tab (click)="tabClicked('INSTANCE_SELECTION')">
                        <a soho-tab-title tabId="lm-builder-properties-filters" data-automation-id="lm-builder-properties-filters-tab">{{ 'Filters' | translate }}</a>
                    </li>
                    <li soho-tab (click)="tabClicked('TOTALING')">
                        <a soho-tab-title tabId="lm-builder-properties-totaling" data-automation-id="lm-builder-properties-properties-tab">{{ 'Totaling' | translate }}</a>
                    </li>
                    <li soho-tab (click)="tabClicked('PROPERTIES')">
                        <a soho-tab-title tabId="lm-builder-properties-properties" data-automation-id="lm-builder-properties-properties-tab">{{ 'Properties' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div soho-tab-panel tabId="lm-builder-properties-columns">
            <lm-builder-display-fields [spec]="spec"></lm-builder-display-fields>
        </div>
        <div soho-tab-panel tabId="lm-builder-properties-filters">
            <lm-builder-filter [spec]="spec"></lm-builder-filter>
        </div>
        <div soho-tab-panel tabId="lm-builder-properties-totaling">
            <lm-builder-totaling [spec]="spec"></lm-builder-totaling>
        </div>
        <div soho-tab-panel tabId="lm-builder-properties-properties">
            <lm-builder-property-panel [spec]="spec"></lm-builder-property-panel>
        </div>
    </div>
}


